/** PinJoint3D registration: the parser. Property knowledge for linting lives in linterParser.ts. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseJoint3D } from '../joint3d/parser';
const pinJoint3DRegistration = {
    typeName: 'PinJoint3D',
    parser: parseJoint3D,
};
nodeRegistry.register(pinJoint3DRegistration);
//# sourceMappingURL=index.js.map